import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import '../../styles/SignUp.scss';
import { Link} from 'react-router-dom';
import logo from '../../Components/Assets/logo.png';
import { useSignUp } from './hooks/useSignUp';
// import ReCAPTCHA from 'react-google-recaptcha';
import { getEnv } from '../../helpers/Env'; 
import { IoEye, IoEyeOff } from "react-icons/io5";
// import GoogleSignIn from './Google';
import countryList from "../../resources/country.json"

interface Country {
  code: string;
  label: string;
  phone: string;
  nationality: string;
}

const SignUp: React.FC = () => {
  // const siteKey = getEnv("GOOGLE_RECAPTCHA") as string;
  const { initialValues, validationSchema, handleSubmit, isSubmitting, errorMessage } = useSignUp();
  const [showPassword, setShowPassword] = useState(false);
  const [countryCodeInput, setCountryCodeInput] = useState("+63");
  const [showDropdown, setShowDropdown] = useState(false);

   const EyeIcon = IoEye as React.ElementType;
   const EyeOffIcon = IoEyeOff as React.ElementType;

   const filteredCountries = countryList.filter((country: Country) =>
    country.label.toLowerCase().includes(countryCodeInput.replace("+", "").toLowerCase()) ||
    country.phone.includes(countryCodeInput.replace("+", "")) ||
    country.code.toLowerCase().includes(countryCodeInput.replace("+", "").toLowerCase())
   );

  return (
    <div className="signup-container">
      <div className="signup-card">
        <Link to="/">
          <img src="https://gottit-media.b-cdn.net/s/GOTTIT-LOGO.PNG" alt="Logo" className="signup-logo" />
        </Link>
        <h2 className="signup-title">PERSONAL DETAILS</h2>
        <p className="signup-text"> Use Google Chrome for seamless expereience.</p>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ handleChange, values, setFieldValue }) => (
            <Form noValidate autoComplete="off" className="signup-form">
              <Field
                type="text"
                name="email_address"
                placeholder="EMAIL"
                className="signup-input"
              />
              <ErrorMessage name="email_address" component="div" className="ca-error-message" />

              <div className="sign-up-password-container">
              <Field
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="PASSWORD"
                className="signup-input"
              />
              <button
                  type="button"
                  className="sign-up-eye-icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeIcon /> : <EyeOffIcon />}
                </button>
              </div>
              <ErrorMessage name="password" component="div" className="ca-error-message" />

              <Field
                type="text"
                name="first_name"
                placeholder="FIRST NAME"
                className="signup-input"
              />
              <ErrorMessage name="first_name" component="div" className="ca-error-message" />

              <Field
                type="text"
                name="last_name"
                placeholder="LAST NAME"
                className="signup-input"
              />
              <ErrorMessage name="last_name" component="div" className="ca-error-message" />
               
               <div className="signup-phone-container">
                <div className="phone-code-dropdown">
                  <Field type="hidden" name="phone_country_code" />
                  <input
                    type="text"
                    value={countryCodeInput}
                    onFocus={() => setShowDropdown(true)}
                    onChange={(e) => {
                      const val = e.target.value;
                      setCountryCodeInput(val);
                      setFieldValue("phone_country_code", val); 
                      setShowDropdown(true);
                    }}
                    onBlur={() => {
                      setTimeout(() => setShowDropdown(false), 150);
                      setFieldValue("phone_country_code", countryCodeInput || "");
                    }}
                    className="signup-input phone-code"
                    placeholder="+63"
                  />

                  {showDropdown && (
                    <ul className="country-dropdown">
                      {filteredCountries.slice(0, 10).map((country: Country) => (
                        <li
                          key={country.code}
                          onMouseDown={() => {
                            setCountryCodeInput(`+${country.phone}`);
                            setFieldValue("phone_country_code", `+${country.phone}`);
                            setShowDropdown(false);
                          }}
                        >
                          {country.label} (+{country.phone})
                        </li>
                      ))}
                      {filteredCountries.length === 0 && (
                        <li className="no-results">No results found</li>
                      )}
                    </ul>
                  )}
                </div>

                <Field
                  type="text"
                  name="phone_number"
                  placeholder="PHONE NUMBER"
                  className="signup-input phone-number"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    let value = e.target.value.replace(/\D/g, '').slice(0, 13);

                    if (value.startsWith("0")) {
                      value = value.substring(1);
                    }

                    let formatted = value;
                     if (value.length > 9) {
                      formatted = `(${value.slice(0, 3)})${value.slice(3, 6)}-${value.slice(6, 10)}-${value.slice(10)}`;
                    } else if (value.length > 6) {
                      formatted = `(${value.slice(0, 3)})${value.slice(3, 6)}-${value.slice(6)}`;
                    } else if (value.length > 3) {
                      formatted = `(${value.slice(0, 3)})${value.slice(3)}`;
                    }
                    // if (value.length >= 7) {
                    //   formatted = `(${value.slice(0, 3)})${value.slice(3, 6)}-${value.slice(6)}`;
                    // } else if (value.length >= 4) {
                    //   formatted = `(${value.slice(0, 3)})${value.slice(3)}`;
                    // }

                    handleChange({ target: { name: 'phone_number', value: formatted } });
                  }}
                  value={values.phone_number}
                />
              </div>
              <ErrorMessage name="phone_country_code" component="div" className="ca-error-message" />
              <ErrorMessage name="phone_number" component="div" className="ca-error-message" />
              {/* <div className="signup-phone-container">
                <Field type="text" name="phone_country_code" value="+63" className="signup-input phone-code" disabled />
                <Field 
                  type="text"
                  name="phone_number"
                  placeholder="PHONE NUMBER"
                  className="signup-input phone-number"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    let value = e.target.value.replace(/\D/g, '').slice(0, 10); 
                
                    if (value.startsWith("0")) {
                      value = value.substring(1);
                    }
                
                    let formatted = value;
                    if (value.length >= 7) {
                      formatted = `(${value.slice(0, 3)})${value.slice(3, 6)}-${value.slice(6)}`;
                    } else if (value.length >= 4) {
                      formatted = `(${value.slice(0, 3)})${value.slice(3)}`;
                    }
                
                    handleChange({ target: { name: 'phone_number', value: formatted } });
                  }}
                  value={values.phone_number}
                />
              </div>
              <ErrorMessage name="phone_number" component="div" className="ca-error-message" /> */}


              <div className="ca-terms-container">
                <Field
                  type="checkbox"
                  name="tnc_accepted"
                  className="ca-terms-checkbox"
                />
                 <label htmlFor="tnc_accepted" className="ca-terms">
                  I have understood the {' '}
                  <Link to="/terms-and-conditions" className="ca-terms">
                    Terms and Conditions
                  </Link>.
                </label>
              </div>
              <ErrorMessage name="tnc_accepted" component="div" className="ca-error-message" />
             
              <div className="ca-terms-container">
                <Field type="checkbox" name="is_bni_member" className="ca-terms-checkbox" />
                <label htmlFor="is_bni_member" className="ca-terms">
                  I'm a <b>BNI</b> member.
                </label>
              </div>
              <div className="bni-info">
                Not yet a member?{' '}
                <a href="https://bni.ph/en-PH/index" target="_blank" rel="noopener noreferrer">
                  Click here
                </a>.
              </div>

              {errorMessage && <div className="ca-error-message">{errorMessage}</div>}

              <button type="submit" className="signup-button" disabled={isSubmitting}>
                CREATE ACCOUNT
              </button>
            </Form>
          )}
        </Formik>
        <a href="/sec/log-in" className="su-back">
          Back To Login
        </a>
      </div>
    </div>
  );
};

export default SignUp;